{
  "actionbar.actions": "Ações",
  "actionbar.actionsAvailable": "Ações disponíveis.",
  "actionbar.clearSelection": "Limpar seleção",
  "actionbar.selected": "{count, plural, =0 {Nenhum selecionado} one {# selecionado} other {# selecionados}}",
  "actionbar.selectedAll": "Tudo selecionado",
  "actionbutton.pending": "pendente",
  "breadcrumbs.more": "Mais artigos",
  "button.pending": "pendente",
  "calendar.invalidSelection": "A(s) {selectedCount, plural, one {data} other {datas}} selecionada(s) não está(ão) disponível/disponível(eis).",
  "combobox.loading": "A carregar...",
  "combobox.loadingMore": "A carregar mais...",
  "combobox.noResults": "Sem resultados",
  "contextualhelp.help": "Ajuda",
  "contextualhelp.info": "Informação",
  "datepicker.endTime": "Terminar tempo",
  "datepicker.startTime": "Iniciar tempo",
  "datepicker.time": "Tempo",
  "dialog.alert": "Alerta",
  "dialog.dismiss": "Dispensar",
  "dropzone.replaceMessage": "Largar ficheiro para substituir",
  "inlinealert.informative": "Informação",
  "inlinealert.negative": "Erro",
  "inlinealert.notice": "Aviso",
  "inlinealert.positive": "Sucesso",
  "label.(optional)": "(opcional)",
  "label.(required)": "(obrigatório)",
  "listview.loading": "A carregar...",
  "listview.loadingMore": "A carregar mais...",
  "menu.loading": "A carregar...",
  "menu.loadingMore": "A carregar mais...",
  "menu.moreActions": "Mais ações",
  "menu.noResults": "Sem resultados",
  "menu.unavailable": "Indisponível, expandir para mais detalhes",
  "notificationbadge.indicatorOnly": "Nova atividade",
  "notificationbadge.plus": "{notifications}+",
  "picker.loading": "A carregar...",
  "picker.loadingMore": "A carregar mais...",
  "picker.placeholder": "Selecionar…",
  "picker.selectedCount": "{count, plural, =0 {Nenhum item selecionado} one {# item selecionado} other {# itens selecionados}}.",
  "sidepanel.collapse": "Fechar o painel lateral",
  "sidepanel.expand": "Expandir o painel lateral",
  "slider.maximum": "Máximo",
  "slider.minimum": "Mínimo",
  "table.cancel": "Cancelar",
  "table.drag": "Arrastar",
  "table.editCell": "Editar célula",
  "table.loading": "A carregar...",
  "table.loadingMore": "A carregar mais...",
  "table.resizeColumn": "Redimensionar coluna",
  "table.save": "Guardar",
  "table.sortAscending": "Ordenar por ordem ascendente",
  "table.sortDescending": "Ordenar por ordem decrescente",
  "tag.actions": "Ações",
  "tag.hideButtonLabel": "Mostrar menos",
  "tag.noTags": "Nenhum",
  "tag.showAllButtonLabel": "Mostrar tudo ({tagCount, number})",
  "toast.clearAll": "Limpar tudo",
  "toast.collapse": "Colapsar",
  "toast.showAll": "Mostrar tudo",
  "treeview.loadingMore": "A carregar mais..."
}
